import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

import { BreederWeekRegistrationField } from './breeder-week-registration-form.component';

export interface BreederWeekRegistrationErrorChecker {
  hasError(field: BreederWeekRegistrationField): boolean;
}

export class BreederWeekRegistrationErrorStateMatcher implements ErrorStateMatcher {
  constructor(
    private readonly errorChecker: BreederWeekRegistrationErrorChecker,
    private readonly field: BreederWeekRegistrationField,
  ) {}

  isErrorState(control: FormControl | null, _form: FormGroupDirective | NgForm | null): boolean {
    return (
      !!control && this.errorChecker.hasError(this.field) && (control.touched || control.dirty)
    );
  }
}
